var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./GuildBoard.less');

module.exports = Section.extend({

    el: '.GuildBoard',

    events: {
        'click .GuildBoard-block': 'toggleBlock',
        'click .GuildBoard-blocks-expand': 'toggleAll'
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    },


    toggleAll: function (e) {
        var $button = $(e.currentTarget);
        var rolledClass = '.GuildBoard-blockRolled';
        var blockClass = '.GuildBoard-block';
        var activeModifier = 'GuildBoard-block--active';
        var $wrapper = $button.closest('.GuildBoard-blocks');

        if ($button.hasClass('GuildBoard-blocks-expand--active')) {
            $wrapper.find(rolledClass).slideUp(0);
            $wrapper.find(blockClass).removeClass(activeModifier);
            $button.text('Expand All');
        } else {
            $wrapper.find(rolledClass).slideDown(0);
            $wrapper.find(blockClass).addClass(activeModifier);
            $button.text('Close All');
        }

        $button.toggleClass('GuildBoard-blocks-expand--active')

    },


    toggleBlock: function (e) {
        var $block = $(e.currentTarget);
        var rolledClass = '.GuildBoard-blockRolled';
        var activeModifier = 'GuildBoard-block--active';

        if ($(e.target).closest(rolledClass).length) return;

        if ($block.hasClass(activeModifier)) {
            $block.find(rolledClass).slideUp(200);
            $block.removeClass(activeModifier);
        } else {
            $block.find(rolledClass).slideDown(200);
            $block.addClass(activeModifier);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildBoard/GuildBoard.js
// module id = 271
// module chunks = 0